/**
 * Valida si el valor es un array.
 * @param {*} value - Valor a validar.
 * @returns {Array} - Si es array, devuelve el mismo array; si no, devuelve [].
 */
export const ensureArray = (value) => {
    return Array.isArray(value) ? value : [];
};


/**
 * Valida si un valor es JSON válido (objeto o string JSON).
 * Si es válido retorna el objeto JSON, si no retorna un objeto vacío {}.
 * @param {*} value - Valor a validar (string o objeto).
 * @returns {object} - El objeto JSON válido o {}.
 */
export const ensureJsonObject = (value) => {
    if (typeof value === 'object' && value !== null) {
        return value;
    }

    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            if (typeof parsed === 'object' && parsed !== null) {
                return parsed;
            }
        } catch {
        }
    }
    return {};
};